import React, { Component } from 'react';
import { Button, Modal as ModalB } from 'react-bootstrap';

class Modal extends Component {
	renderButton() {
		let { formType, stateSetter, createUser, isCUDing, deleteUser, selectedData } = this.props;

		var closeButton = (
			<Button
				disabled={isCUDing ? 'true' : ''}
				onClick={() => {
					if (!isCUDing) {
						stateSetter([
							{ state: 'showModal', value: false },
							// {state: 'selectedData', value: selectedData.revert()},
							{ state: 'formType', value: '' },
							{ state: 'showAlert', value: false },
						]);
					}
				}}
			>
				CLOSE
			</Button>
		);

		var loadingIcon = <i className="fa fa-spinner fa-spin" style={{ color: 'white' }}></i>;
		var disabledStyle = isCUDing ? 'true' : '';

		switch (formType.toUpperCase()) {
			case 'CREATE':
				return (
					<div>
						{closeButton}
						<Button
							className="btn-primary"
							disabled={disabledStyle}
							onClick={() => createUser()}
						>
							<span>
								{isCUDing ? loadingIcon : ''}
								&nbsp; CREATE
							</span>
						</Button>
					</div>
				);
				break;
			case 'UPDATE':
				return (
					<div>
						{closeButton}
						<Button
							className="btn-primary"
							disabled={disabledStyle}
							onClick={() => createUser()}
						>
							<span>
								{isCUDing ? loadingIcon : ''}
								&nbsp; UPDATE
							</span>
						</Button>
					</div>
				);
				break;
			case 'VIEW':
				return <div>{closeButton}</div>;
				break;
			case 'DELETE':
				return (
					<div>
						<Button
							disabled={disabledStyle}
							onClick={() => {
								if (!isCUDing) {
									stateSetter([
										{ state: 'showModal', value: false },
										{ state: 'selectedData', value: selectedData.revert() },
										{ state: 'formType', value: '' },
									]);
								}
							}}
						>
							NO
						</Button>
						<Button
							className="btn-primary"
							disabled={disabledStyle}
							onClick={() => deleteUser()}
						>
							<span>
								{isCUDing ? loadingIcon : ''}
								&nbsp; YES
							</span>
						</Button>
					</div>
				);
				break;
			default:
		}
	}

	render() {
		let { showModal, formType, stateSetter, isCUDing, children, selectedData } = this.props;

		return (
			<ModalB
				show={showModal}
				onHide={() => {
					if (!isCUDing) {
						stateSetter([
							{ state: 'showModal', value: false },
							// {state: 'selectedData', value: selectedData.revert()},
							{ state: 'formType', value: '' },
							{ state: 'showAlert', value: false },
							{ state: 'alertMessage', value: '' },
						]);
					}
				}}
			>
				<ModalB.Header closeButton>
					<ModalB.Title>{formType.toUpperCase()}</ModalB.Title>
				</ModalB.Header>
				<ModalB.Body>{children}</ModalB.Body>
				<ModalB.Footer>{this.renderButton()}</ModalB.Footer>
			</ModalB>
		);
	}
}

export default Modal;



// WEBPACK FOOTER //
// ./components/UserSetup/Modal.js